import Stack from "@mui/material/Stack";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";
import React, { useState } from "react";
import TabPanel from "../../components/TabPanel";
import { useStyles } from "./styles";
import { Calendar } from "./Tabs/Calendar";
import { Gallery } from "./Tabs/Gallery";
import { MyBackgrounds } from "./Tabs/MyBackgrounds";
import { MyModels } from "./Tabs/MyModels";

export function Studio() {
  const styles = useStyles();

  const [currentTab, setCurrentTab] = useState(0);

  const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
    setCurrentTab(newValue);
  };

  return (
    <Stack spacing={2}>
      <div className={styles.root}>
        <Typography variant="h6">Estúdio de criação</Typography>
        <Typography variant="body2">
          Crie artes personalizadas com a sua lista de produtos e veja suas
          propagandas aqui.
        </Typography>
      </div>
      <div className={styles.rootActions}>
        <Tabs
          value={currentTab}
          onChange={handleChangeTab}
          aria-label="basic tabs example"
        >
          <Tab label="Galeria" />
          <Tab label="Calendário" />
          <Tab label="Meus modelos" />
          <Tab label="Meus fundos" />
        </Tabs>
      </div>
      <TabPanel value={currentTab} index={0}>
        <Gallery />
      </TabPanel>
      <TabPanel value={currentTab} index={1}>
        <Calendar />
      </TabPanel>
      <TabPanel value={currentTab} index={2}>
        <MyModels />
      </TabPanel>
      <TabPanel value={currentTab} index={3}>
        <MyBackgrounds />
      </TabPanel>
    </Stack>
  );
}
